import React, { useState, useRef, useEffect } from "react";
import { Controller } from "react-hook-form";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";

export default function CustomSelect({
  name,
  label,
  control,
  options,
  loading,
  resett,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  }, [isOpen]);

  let filteredOptions = [];
  if (name === "dp") {
    filteredOptions = options;
  } else {
    filteredOptions =
      options.length > 0
        ? options.filter((opt) =>
            opt.toLowerCase().startsWith(search?.toLowerCase())
          )
        : null;
  }

  useEffect(() => {
    if (resett) setSearch("");
  }, [resett]);

  const sanitizeDropdownValue = (value) => {
    let v = value.toUpperCase();
    v = v.replace(/[^A-Z ]/gi, "");
    v = v.replace(/\s{2,}/g, " ");
    v = v.replace(/^\s+/, "");
    return v;
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        if (field.value) {
          setSearch(field.value);
        }
        return (
          <div ref={containerRef} className="col-md-3 col-sm-3 col-6">
            <div className="form-group">
              <label className="form-label">
                {label} <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ position: "relative" }}>
                <input
                  ref={inputRef}
                  value={field.value || ""}
                  readOnly={name === "dp" ? true : false}
                  onChange={(e) => {
                    const cleaned = sanitizeDropdownValue(e.target.value);
                    setSearch(cleaned);
                    field.onChange(cleaned);
                  }}
                  onClick={() => setIsOpen(true)}
                  className={`input-text form-control ${
                    fieldState.error ? "is-invalid" : "mb-4"
                  }`}
                  placeholder={name==="dp"?"Select DP":`Select/Search ${label}`}
                  onBlur={field.onBlur}
                />

                {isOpen && (
                  <div
                    className="customSelect"
                    style={{
                      marginTop: fieldState.error ? 0 : "-13px",
                    }}
                  >
                    {loading || filteredOptions === null ? (
                      <div className="loaderDiv">
                        <LoaderForSearch />
                      </div>
                    ) : filteredOptions?.length > 0 ? (
                      filteredOptions.map((opt, idx) => (
                        <div
                          key={idx}
                          onClick={() => {
                            field.onChange(opt);
                            setSearch(opt);
                            setIsOpen(false);
                          }}
                          className="options"
                        >
                          {opt}
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "8px", color: "#888" }}>
                        No options
                      </div>
                    )}
                  </div>
                )}
              </div>
              {fieldState.error && (
                <div className="invalid-feedback d-block">
                  {fieldState.error.message}
                </div>
              )}
            </div>
          </div>
        );
      }}
    />
  );
}
